"use client";

import { useState } from "react";
import { Bike, MapPin, Navigation, CircleParking as ParkingCircle, TrainFront as Train } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurLocation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const [hoveredPin, setHoveredPin] = useState<number | null>(null);
  const nearbyLandmarks = [{
    name: "Senior Wellness Center",
    top: "28%",
    left: "62%"
  }, {
    name: "Community Health Hub",
    top: "42%",
    left: "78%"
  }, {
    name: "Central Transit Station",
    top: "68%",
    left: "55%"
  }, {
    name: "Medical District",
    top: "35%",
    left: "38%"
  }, {
    name: "Caregiver Support Office",
    top: "58%",
    left: "30%"
  }];
  const transitInfo = [{
    icon: Train,
    label: "2 min from Central Transit"
  }, {
    icon: Bike,
    label: "Secure bike parking available"
  }, {
    icon: ParkingCircle,
    label: "Validated visitor parking"
  }];
  return;
}